/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState} from "react";
import {RouteComponentProps, withRouter} from "react-router";
import {IonCheckbox, IonGrid, IonItem, IonLabel} from "@ionic/react";

interface TypeProps {
	data?: any;
	id?: number;
	updateIdData?: any;
	isSelected?: any;
}

const Type997: React.FC<TypeProps & RouteComponentProps> = ({data, id, updateIdData, isSelected}) => {
	const [list, setList] = useState<any>();
	const [selectedItemNum, setSelectedItemNum] = useState<any>([]);
	const [isSelectedItem, setIsSelectedItem] = useState<boolean>(false);

	const [isChecked, setIsChecked] = useState<boolean>(false);
	const [isChecked2, setIsCheckedd2] = useState<boolean>(false);

	const handleSelectedItem = (e: any, index: number) => {
		const selectedItems = [...list];
		const selectedItemNums = [...selectedItemNum];
		const value = e.detail.value;

		if (e.detail.checked) {
			selectedItems[index].checked = true;

			if (value === "해당 없음") {
				selectedItems.find(item => {
					if (item.title !== "해당 없음") {
						item.checked = false;
					} else {
						selectedItems[selectedItems.length - 1].checked = true;
						setSelectedItemNum([item.id]);
					}
				});
			} else {
				selectedItemNums.push(selectedItems[index].id);
				setSelectedItemNum(selectedItemNums);

				selectedItems.map(item => {
					if (item.title === "해당 없음") {
						item.checked = false;
						selectedItems[selectedItems.length - 1].checked = false;
					}
				});
			}

			setList(selectedItems);
		} else {
			[...list][index].checked = false;

			const selectedItemNums = [...selectedItemNum].filter(v => v !== selectedItems[index].id);
			setSelectedItemNum(selectedItemNums);
		}

		if (selectedItems) {
			const selectedItemsState = selectedItems.map(item => {
				if (item.checked === true) {
					return true;
				} else {
					return false;
				}
			});

			if (selectedItemsState.includes(true)) {
				setIsSelectedItem(true);
			} else {
				setIsSelectedItem(false);
			}
		}

		setList(selectedItems);
	};

	const handleClickOkButton = (id: any) => {
		if (id === 1) {
			setIsChecked(true);
		} else if (id === 2) {
			setIsCheckedd2(true);
		}
	};

	useEffect(() => {
		setList(data.moonjinLabelPageDto.moonjinLabelDetailList);
		setSelectedItemNum([]);
	}, [data]);

	useEffect(() => {
		if (selectedItemNum.length === 0) {
			setIsSelectedItem(false);
		}
	}, [selectedItemNum]);

	useEffect(() => {
		updateIdData(selectedItemNum);
	}, [selectedItemNum]);

	useEffect(() => {
		isSelected(isSelectedItem);
	}, [isSelectedItem]);

	useEffect(() => {
		setIsSelectedItem(false);
	}, []);

	return (
		<div className="question-contents__list--wrap">
			<div className="question-contents__list--title">
				<div className="ion-padding">
					<span className="num">질문{id}</span>
					<p className="category">{data.moonjinLabelPageDto.title}</p>
					<span className="description">(중복 선택 가능)</span>
				</div>
			</div>
			<IonGrid className="question-contents__list list">
				<div className="question-contents__list--item">
					{list?.map((item: any, index: any) => (
						<div
							className={`list-wrap multiple-check${
								(item.exceptCode === 14 && !isChecked) || (item.exceptCode === 15 && !isChecked2)
									? " hide"
									: ""
							}`}
							key={index}
							onClick={() => handleClickOkButton(index)}
						>
							<IonItem className="lines-item type">
								<IonCheckbox
									value={item.title}
									onIonChange={e => handleSelectedItem(e, index)}
									checked={item.checked}
								/>
								<IonLabel>
									<p>{item.title}</p>
								</IonLabel>
							</IonItem>
						</div>
					))}
				</div>
			</IonGrid>
		</div>
	);
};

export default withRouter(Type997);
